import React from 'react';
import './Playerbar.scss';
import PlayControl from './PlayControl/PlayControl';
import VolumeControl from './VolumeControl/VolumeControl';
import Secondary from './Secondary/Secondary';
import helpers from '../helpers';

const Playerbar = ({ channel, playerReady }) => {
    return (
        <div className="Playerbar">
            <PlayControl playerReady={playerReady} />
            {!helpers.isMobile && <VolumeControl playerReady={playerReady} />}
            <Secondary channel={channel} />
        </div>
    );
}



export default Playerbar;
